import React from 'react';
import { Chip, ChipProps } from '../../Chip';

export interface QuickFilterButtonProps {
  displayName: string;
  filterKey: string;
  isSelected: boolean;
  onClick: () => void;
  icon?: React.ReactElement;
  size?: ChipProps['size'];
}

const tickIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none">
    <path d="M9 1L3.5 6.5L1 4" stroke="inherit" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/**
 * A quick filter button built on top of the Chip component.
 */
export const QuickFilterButton: React.FC<QuickFilterButtonProps> = ({
  displayName,
  filterKey,
  isSelected,
  onClick,
  icon,
  size = 'medium',
}: QuickFilterButtonProps) => {
  return (
    <Chip
      size={size}
      color={isSelected ? 'primary' : 'default'}
      label={displayName}
      onClick={() => onClick()}
      data-testid={`quick-filter-${filterKey}`}
      endAdornment={isSelected ? { mode: 'icon', icon: tickIcon } : undefined}
      startAdornment={icon ? { mode: 'icon', icon: icon } : undefined}
      aria-pressed={isSelected}
    />
  );
};
